import { SERVER } from "../configs/config";
import { OrderType } from "./interfaces";
import { RiEBike2Line } from "react-icons/ri";
import { MdOutlineShoppingBag } from "react-icons/md";

export enum TagType {
  Auth = "Auth",
  Restaurant = "Restaurant",
  Order = "Order",
  Header = "Header",
  Item = "Item",
  ModifierOption = "ModifierOption",
}

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export const TagId = {
  LIST: "LIST",
  LIST_PAST: "LIST_PAST",
} as const;

const APIS = {
  AUTH: {
    reducerPath: "auth",
    baseUrl: SERVER.URL + "/auth",
    tagTypes: [TagType.Auth],
  },
  RESTAURANT: {
    reducerPath: "restaurants",
    baseUrl: SERVER.URL + "/restaurants",
    tagTypes: [TagType.Restaurant],
  },
  ORDER: {
    reducerPath: "orders",
    baseUrl: SERVER.URL + "/orders",
    tagTypes: [TagType.Order],
  },
  HEADER: {
    reducerPath: "headers",
    baseUrl: SERVER.URL + "/headers",
    tagTypes: [TagType.Header],
  },
  ITEM: {
    reducerPath: "items",
    baseUrl: SERVER.URL + "/items",
    tagTypes: [TagType.Item],
  },
  MODIFIER_OPTION: {
    reducerPath: "modifierOptions",
    baseUrl: SERVER.URL + "/modifier-options",
    tagTypes: [TagType.ModifierOption],
  },
};

export const SLICES = {
  SESSION: {
    NAME: "session",
    RTK_KEY: "rtk:session",
    WHITE_LIST: ["restaurant", "accessToken"],
  },
};

const LISTS = {
  DELIVERY_OPTIONS: [
    {
      label: OrderType.DELIVERY,
      icon: RiEBike2Line,
    },
    {
      label: OrderType.PICKUP,
      icon: MdOutlineShoppingBag,
    },
  ],
};

export const { AUTH, RESTAURANT, ORDER, HEADER, ITEM, MODIFIER_OPTION } = APIS;
export const { SESSION } = SLICES;
export const { DELIVERY_OPTIONS } = LISTS;
